import { bookableAreasClosed } from "../../types/venues";
import { dmnIdentity } from "../../utils/dmnIdentity";
import { getEnvironmentProps } from "../../utils/environment";
import { errorHandler, apiFetchNotOkHandler } from "../errorHandler";

type UpdateVenuePayload = {
  bookable_areas_closed: bookableAreasClosed[];
};

type UpdateVenueResponse = {
  payload?: {
    venue: any;
  };
  status: number;
};

type UpdateVenueProps = {
  venueId: string;
  bookableAreasClosed: bookableAreasClosed[];
};

export const updateVenue = async ({
  venueId,
  bookableAreasClosed
}: UpdateVenueProps): Promise<UpdateVenueResponse | undefined> => {
  if (!venueId) {
    return undefined;
  }

  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  const payload: UpdateVenuePayload = {
    bookable_areas_closed: bookableAreasClosed
  };

  try {
    const response = await fetch(
      `${environmentVars?.CORE_API_BASE_URL}/venues/${venueId}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      }
    );

    if (!response.ok) {
      apiFetchNotOkHandler(response, "Error updating venue");
      return undefined;
    }

    return await response.json();
  } catch (error) {
    errorHandler(error, "Error updating venue");
    return undefined;
  }
};
